import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import { PropsWithChildren } from 'react';
import { Modal, ModalProps } from './Modal';
import { SelectPill } from './SelectPill';

interface ModalSelectProps extends ModalProps {
  selectors?: Array<ModalSelectItemsProps>;
}
interface ModalSelectItemsProps {
  style?: React.CSSProperties;
  selected?: boolean;
  radialIcon?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

export const ModalSelect = ({
  open,
  onClose,
  title,
  subtitle,
  isLoading,
  selectors,
  buttons,
  children,
}: PropsWithChildren<ModalSelectProps>) => {
  return (
    <Modal open={open} onClose={onClose} title={title} subtitle={subtitle} isLoading={isLoading} buttons={buttons}>
      {children && (
        <>
          {children}
          <VSpacer small />
        </>
      )}

      {selectors && (
        <Grid container direction="column" style={{ width: `100%` }}>
          {selectors.map(({ style, ...selectorProps }, index) => (
            <div key={`modal-select-${index}`}>
              <SelectPill containerStyle={{ ...style }} {...selectorProps} />
              <VSpacer small />
            </div>
          ))}
        </Grid>
      )}
    </Modal>
  );
};
